<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Liste Postes</h1>
    <div class="mb-6 flex justify-between items-center">
      <search-filter v-model="sForm.search" class="w-full max-w-md mr-4" @reset="reset">
        <!--        <label class="mt-4 block text-gray-700">Envoyer au superviseur:</label>-->
        <select class="mt-1 w-full form-select">
          <option :value="null"/>
          <!--          <option value="with">Envoyer et non envoyer</option>
                    <option value="only">Envoyer uniquement</option>-->
        </select>
      </search-filter>
      <div class="flex">
      </div>
    </div>
    <div class="bg-white rounded shadow overflow-x-auto">
      <table class="w-full whitespace-no-wrap">
        <tr class="text-left font-semibold">
          <th class="px-2 pt-6 pb-4"><input type="checkbox" class="form-checkbox h-5 w-5" v-model="selectAll" @change="select"></th>
          <th class="px-2 pt-6 pb-4">N° Order</th>
          <th class="px-2 pt-6 pb-4">IMEI</th>
          <th class="px-2 pt-6 pb-4">Modele</th>
          <th class="px-2 pt-6 pb-4">Panne</th>
          <th class="px-2 pt-6 pb-4">Garantie</th>
          <th class="px-2 pt-6 pb-4">Creation</th>
          <th class="px-2 pt-6 pb-4">Status</th>
        </tr>
        <tr v-for="repair in repairs.data" :key="repair.id" class="hover:bg-gray-100 focus-within:bg-gray-100"
            :class="{'bg-yellow-100': repair.return, 'bg-orange-200': repair.bounce}">
        <td class="border-t">
            <div class="px-2 py-4 flex items-center focus:text-indigo-500">
              <input type="checkbox" class="form-checkbox h-5 w-5" :value="repair.id" v-model="selectedItems">
            </div>
          </td>
          <td class="border-t">
            <span class="px-2 py-4 flex items-center focus:text-indigo-500">
              {{ repair.id }}
              <icon v-if="repair.deleted_at" name="trash" class="flex-shrink-0 w-3 h-3 fill-gray-400 ml-2"/>
            </span>
          </td>
          <td class="border-t">
            <span class="px-2 py-4 flex items-center">
              {{ repair.imei }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-2 py-4 flex items-center" >
              {{ repair.model }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-2 py-4 flex items-center">
              {{ repair.malfunction }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-2 py-4 flex items-center">
              {{ repair.warranty }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-2 py-4 flex items-center" :title="repair.creation_date">
              {{ repair.created_at }}
            </span>
          </td>
          <td class="border-t">
            <span class="px-2 py-4 flex items-center">
              {{ repair.status }}
            </span>
          </td>
          <td class="border-t">
            <span class="cursor-pointer" title="Reparation" @click="showRepairForm(repair)">
              <svg class="h-10 w-10 mx-auto text-indigo-600 hover:text-indigo-800" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </span>
          </td>
          <td class="border-t">
            <span class="cursor-pointer" title="Commande pieces" @click="showOrderPartsForm(repair)">
              <svg class="h-10 w-10 mx-auto text-blue-500 hover:text-blue-700" :class="{'cursor-not-allowed opacity-25':orderPartsFormDisabled(repair)}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
              </svg>
            </span>
          </td>
          <td class="border-t">
            <span class="cursor-pointer" title="Envoyer au devis" @click="showDevisForm(repair)">
              <svg class="h-10 w-10 mx-auto text-green-600 hover:text-green-800" :class="{'cursor-not-allowed opacity-25':repair.with_quote !== 1 || (repair.quote != null && repair.quote.accepted == 1)}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
              </svg>
            </span>
          </td>
          <td class="border-t">
            <span class="cursor-pointer" title="Envoyer au test" @click="showTestForm(repair)">
              <svg class="h-10 w-10 mx-auto text-green-500 hover:text-green-700" :class="{'cursor-not-allowed opacity-25':testFormDisabled(repair)}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                   stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"/>
              </svg>
            </span>
          </td>
          <td class="border-t">
            <span class="cursor-pointer" title="poste irreparable" @click="showIrreparableForm(repair)">
              <svg class="h-10 w-10 mx-auto text-red-500 hover:text-red-600" :class="{'cursor-not-allowed opacity-25':repair.order != null }" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"/>
              </svg>
            </span>
          </td>
<!--          <td class="border-t">
            <span class="cursor-pointer" title="Ajouter un commentaire" @click="showCommentForm(repair)">
              <svg class="h-10 w-10 mx-auto text-gray-500 hover:text-gray-700" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z"/>
              </svg>
            </span>
          </td>-->
          <td class="border-t w-px">
            <inertia-link title="Details" class="px-4 flex items-center" href="#" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400"/>
            </inertia-link>
          </td>
        </tr>
        <tr v-if="repairs.data.length === 0">
          <td class="border-t px-2 py-4" colspan="4">No reception found.</td>
        </tr>
      </table>

      <!-- Repair Modal  -->
      <jet-dialog-modal :show="repairForm" max-width="4xl" :closeable="false" @close="repairForm = false">
        <template #title>
          Reparation
        </template>
        <template #content>
          <div class="mt-4 pb-2">
            <div class="flex flex-wrap">
              <text-input v-model="form.repair.imei" :error="errors.imei" class="px-3 pb-8 w-full lg:w-1/3" label="IMEI"/>
              <div class="px-3 pb-8 w-full lg:w-1/3">
                <label class="form-label">Modèle:</label>
                <multiselect v-model="form.repair.model" deselect-label="supprimer" track-by="name" label="name" placeholder="Select one"
                             :options="models" :searchable="true" :clear-on-select="false"
                             open-direction="bottom" @input="findParts(form.repair)">
                </multiselect>
                <div v-if="errors.model" class="form-error">{{ errors.model }}</div>
              </div>
              <div class="px-3 pb-8 w-full lg:w-1/3">
                <label class="form-label">Panne:</label>
                <multiselect v-model="form.repair.malfunction" deselect-label="supprimer" track-by="name" label="name" placeholder="Select one"
                             :options="malfunctions" :searchable="true" :clear-on-select="false"
                             open-direction="bottom">
                </multiselect>
                <div v-if="errors.malfunction" class="form-error">{{ errors.malfunction }}</div>
              </div>
              <div class="px-3 pb-8 w-full lg:w-1/3">
                <label class="form-label">Reparation couverte par la Garantie:</label>
                <div class="pl-2">
                  <label>
                    <input v-model="form.repair.warranty" type="radio" name="warranty" value="1">
                    Sous garantie</label>
                </div>
                <div class="pl-2">
                  <label>
                    <input v-model="form.repair.warranty" type="radio" name="warranty" value="0">
                    Hors garantie</label>
                </div>
                <div v-if="errors.warranty" class="form-error">{{ errors.warranty }}</div>
              </div>
              <div class="px-3 pb-8 w-full lg:w-1/3">
                <label class="form-label">Avec piece(s):</label>
                <div class="pl-2">
                  <label>
                  <input v-model="form.repair.with_parts" type="radio" name="parts" value="1">
                  Oui</label>
                </div>
                <div class="pl-2">
                  <label>
                  <input v-model="form.repair.with_parts" type="radio" name="parts" value="0">
                  Non</label>
                </div>
                <div v-if="errors.with_parts" class="form-error">{{ errors.with_parts }}</div>
              </div>
              <div class="px-3 pb-8 w-full lg:w-1/3">
                <label class="form-label">Avec devis:</label>
                <div class="pl-2">
                  <label>
                  <input v-model="form.repair.with_quote" type="radio" name="quote" value="1">
                  Oui</label>
                </div>
                <div class="pl-2">
                  <label>
                  <input v-model="form.repair.with_quote" type="radio" name="quote" value="0">
                  Non</label>
                </div>
                <div v-if="errors.with_quote" class="form-error">{{ errors.with_quote }}</div>
              </div>
              <div class="px-3 pb-8 w-full lg:w-1/3" v-if="form.repair.with_parts == 0">
                <label class="form-label">Réparation a effectuer:</label>
                <select v-model="form.repair.reparationType" class="form-select" :error="errors.reparationType">
                  <option v-for="type in repairsPrice" :key="type.id" :value="type.id" :selected="type.id == form.repair.reparationType">{{ type.name }}</option>
                </select>
                <div v-if="errors.reparationType" class="form-error">{{ errors.reparationType }}</div>
              </div>
              <div class="px-3 pb-8 w-full lg:w-1/3"  v-if="showPredefinedPrices">
                <label class="form-label">Prix:</label>
                <select v-model="form.repair.reparationTypePrice" class="form-select" :error="errors.reparationType" @change="calcul(form.repair.reparationTypePrice)">
                  <option v-for="price in repairsPrice[form.repair.reparationType-1].prices" :key="parseFloat(price)" :value="parseFloat(price)"
                          :selected="parseFloat(price) == parseFloat(form.repair.calculatedPrice)">{{ price }}</option>
                </select>
                <div v-if="errors.reparationTypePrice" class="form-error">{{ errors.reparationTypePrice }}</div>
              </div>
              <div class="px-3 pb-8 w-full lg:w-1/3" v-if="form.repair.with_parts == 1">
                <label class="form-label">Type de reparaton:</label>
                <multiselect v-model="form.repair.reparations" deselect-label="supprimer" track-by="id" label="name" placeholder="Select one"
                             :options="repairsType" :searchable="true" :clear-on-select="false" open-direction="bottom" :multiple="true" :taggable="true" :max-height="200">
                </multiselect>
                <div v-if="errors.reparations" class="form-error">{{ errors.reparations }}</div>
              </div>
              <div class="px-3 pb-8 w-full lg:w-1/3" v-if="form.repair.with_parts == 1">
                <label class="form-label">Categorie:</label>
                <multiselect v-model="form.repair.partsCategory" deselect-label="supprimer" track-by="id" label="name" placeholder="Select one" @input="filterParts"
                             :options="categories" :searchable="true" :clear-on-select="false" open-direction="bottom">
                  <template slot="noOptions">categorie indisponible</template>
                </multiselect>
                <div v-if="errors.parts" class="form-error">{{ errors.parts }}</div>
              </div>
              <div class="px-3 pb-8 w-full lg:w-1/3" v-if="form.repair.with_parts == 1">
                <label class="form-label">Piece(s):</label>
                <multiselect v-model="form.repair.parts" deselect-label="supprimer" track-by="id" label="reference" placeholder="Select one" @input="calculMargin"
                             :options="parts" :searchable="true" :clear-on-select="false" open-direction="bottom" :multiple="true" :taggable="true">
                  <template slot="noOptions">piece indisponible pour ce model</template>
                </multiselect>
                <div v-if="errors.parts" class="form-error">{{ errors.parts }}</div>
              </div>

              <div v-if="form.repair.with_parts == 1 && form.repair.with_quote == 1" v-for="(part,index) in form.repair.parts" class="px-3 pb-4 pt-4 w-full flex flex-wrap border-b border-t divide-gray-400">
                <div class="px-3 pb-8 w-full lg:w-1/3">
                  <label class="form-label w-full">Piece:</label>
                  <span class="bg-green-500 p-2 rounded-xl text-white">{{ part.reference }}</span>
                </div>

                <div class="px-3 pb-4 w-full lg:w-1/3">
                  <label class="form-label">Garantie piece:</label>
                  <div class="pl-2">
                    <label>
                      <input type="radio" :name="'partsWarranty'+index" :checked="partIsChecked(part.id)" value="1" @change="partsWarrantyHandler($event,part.id)">
                      Sous garantie</label>
                  </div>
                  <div class="pl-2">
                    <label>
                      <input type="radio" :name="'partsWarranty'+index" :checked="!partIsChecked(part.id)" value="0" @change="partsWarrantyHandler($event,part.id)">
                      Hors garantie</label>
                  </div>
                  <div v-if="errors.partsWarranty" class="form-error">{{ errors.partsWarranty }}</div>
                </div>
              </div>

              <div class="px-3 pb-4 pt-4 w-full lg:w-1/3 flex flex-wrap" v-if="showMargin">
                  <label class="form-label w-full">Marge:</label>
                  <div class="w-full lg:w-1/2 pr-2">
                    <multiselect v-model="form.repair.percent" track-by="value" label="value" placeholder="Pourcentage" selectLabel="%"
                                 open-direction="bottom"
                                 :options="form.repair.percentMargins">
                      <template slot="singleLabel" slot-scope="{ option }">{{ option.value }}%</template>
                    </multiselect>
                    <div v-if="errors.percent" class="form-error">{{ errors.percent }}</div>
                  </div>
                  <div class="w-full lg:w-1/2">
                    <multiselect v-model="form.repair.amount" track-by="value" label="value" placeholder="Montant" selectLabel="Dh"
                                 open-direction="bottom"
                                 :options="form.repair.amountMargins">
                      <template slot="singleLabel" slot-scope="{ option }">{{ option.value }} Dh</template>
                    </multiselect>
                    <div v-if="errors.amount" class="form-error">{{ errors.amount }}</div>
                  </div>
                </div>

              <div class="px-3 pb-4 pt-4  w-full lg:w-1/3" v-if="form.repair.with_quote == 1">
                <label class="form-label text-gray-800">Prix total:</label>
                <p class="font-bold p-2 border border-gray-400 rounded h-10">{{form.repair.calculatedPrice}} <i v-if="form.repair.calculatedPrice">Dh</i></p>
                <div v-if="errors.calculatedPrice" class="form-error">{{ errors.calculatedPrice }}</div>
              </div>
            </div>
          </div>
        </template>
        <template #footer>
          <jet-secondary-button @click.native="repairForm = false">
            Annuler
          </jet-secondary-button>
          <jet-button class="bg-green-600 hover:bg-green-500 focus:border-green-700 focus:shadow-outline-green"
                      :class="{ 'opacity-25': form.repair.processing }" :disabled="form.repair.processing"
                      @click.native="saveRepairParams">
            Sauvegarder
          </jet-button>
        </template>
      </jet-dialog-modal>

      <!-- Send to Test Modal -->
      <jet-dialog-modal :show="sendToTestForm" :closeable="false" @close="sendToTestForm = false">
        <template #title>
          Envoyer au Test Final
        </template>
        <template #content>
          <div class="mt-4">
            <div class="flex flex-wrap">
              <text-input v-model="form.test.swap_imei" :error="errors.swap_imei" v-if="form.test.hasSwap" autocomplete="off" class="px-3 pb-8 w-full lg:w-1/2" label="Nouveau IMEI"/>
              <div class="px-3 pb-8 w-full lg:w-full">
                <textarea-input v-model="form.test.comment" :error="errors.comment" label="Commentaire Technique" :optional="true"/>
              </div>
              <div class="px-3 pb-8 w-full lg:w-full">
                <textarea-input v-model="form.test.commentClient" :error="errors.comment" label="Commentaire Client" :optional="true"/>
              </div>
            </div>
          </div>
        </template>
        <template #footer>
          <jet-secondary-button @click.native="sendToTestForm = false">
            Annuler
          </jet-secondary-button>
          <jet-button class="bg-green-600 hover:bg-green-500 focus:border-green-700 focus:shadow-outline-green"
                      :class="{ 'opacity-25': form.processing }" :disabled="form.processing"
                      @click.native="sendToTest('test')">
            Envoyer
          </jet-button>
        </template>
      </jet-dialog-modal>

      <!-- Send to Devis Modal -->
      <jet-dialog-modal :show="sendToDevisForm" :closeable="false" @close="sendToDevisForm = false">
        <template #title>
          Envoyer au Devis
        </template>
        <template #content>
          <div class="mt-4">
            <div class="flex flex-wrap">
              <div class="px-3 pb-8 w-full lg:w-1/2" v-if="form.quote.parts != null && form.quote.parts.length !== 0">
                <label class="form-label">Piece(s):</label>
                <multiselect v-model="form.quote.parts" disabled="disabled" deselect-label="supprimer" track-by="id" label="reference" :multiple="true" :taggable="true"
                             :options="parts">
                </multiselect>
                <div v-if="errors.parts" class="form-error">{{ errors.parts }}</div>
              </div>
              <div class="px-3 pb-8 w-full lg:w-1/2" v-if="form.quote.reparationType != null">
                <label class="form-label">Réparation effectuer:</label>
                <select v-model="form.quote.reparationType" class="form-select" disabled="disabled" :error="errors.reparationType" label="Réparation a effectuer">
                  <option v-for="type in repairsPrice" :key="type.id" :value="type.id" :selected="type.id == form.quote.reparationType">{{ type.name }}</option>
                </select>
                <div v-if="errors.reparationType" class="form-error">{{ errors.reparationType }}</div>
              </div>
              <div class="px-3 pb-8 w-full lg:w-1/3">
                <label class="form-label text-gray-800">Prix total:</label>
                <p class="font-bold p-2 border border-gray-400 rounded h-10">{{form.quote.totalPrice}} Dh</p>
              </div>
              <div class="px-3 pb-8 w-full lg:w-full">
                <textarea-input v-model="form.quote.comment" :error="errors.comment" label="Commentaire interne" :optional="true"/>
              </div>
              <div class="px-3 pb-8 w-full lg:w-full">
                <textarea-input v-model="form.quote.clientComment" :error="errors.clientComment" label="Commentaire client" :optional="true"/>
              </div>
            </div>
          </div>
        </template>
        <template #footer>
          <jet-secondary-button @click.native="sendToDevisForm = false">
            Annuler
          </jet-secondary-button>
          <jet-button class="bg-green-600 hover:bg-green-500 focus:border-green-700 focus:shadow-outline-green"
                      :class="{ 'opacity-25': form.processing }" :disabled="form.processing"
                      @click.native="sendToDevis">
            Envoyer
          </jet-button>
        </template>
      </jet-dialog-modal>

      <!-- Order parts Modal -->
      <jet-dialog-modal :show="orderPartsForm" :closeable="false" @close="orderPartsForm = false">
        <template #title>
          Commande pieces
        </template>
        <template #content>
          <div class="mt-4">
            <div class="flex flex-wrap">
              <div class="px-3 pb-8 w-full">
                <label class="form-label">Piece(s):</label>
                <multiselect v-model="form.parts.parts"  track-by="id" label="reference" disabled="disabled" :multiple="true" :taggable="true" :options="parts">
                </multiselect>
                <div v-if="errors.parts" class="form-error">{{ errors.parts }}</div>
              </div>
<!--              <div class="px-3 pb-8 w-full lg:w-1/2">
                <label class="form-label">Test piece:</label>
                  <input type="checkbox" class="form-checkbox" value="1">
                  <span class="mx-2 align-middle text-md">Commande pour test ?</span>
              </div>-->
              <div class="px-3 pb-8 w-full lg:w-full">
                <textarea-input v-model="form.parts.comment" :error="errors.comment" label="Commentaire" :optional="true"/>
              </div>
            </div>
          </div>
        </template>
        <template #footer>
          <jet-secondary-button @click.native="orderPartsForm = false">
            Annuler
          </jet-secondary-button>
          <jet-button class="bg-green-600 hover:bg-green-500 focus:border-green-700 focus:shadow-outline-green" @click.native="sendPartsOrder"
                      :class="{ 'opacity-25': form.parts.processing }" :disabled="form.parts.processing">
            Envoyer
          </jet-button>
          <jet-danger-button class="focus:shadow-outline-green" v-if="form.parts.processing" @click.native="cancelPartsOrder">
            Annuler la Commande
          </jet-danger-button>
        </template>
      </jet-dialog-modal>

      <!-- irreparable Modal -->
      <jet-dialog-modal :show="irreparableForm" :closeable="false" @close="irreparableForm = false">
        <template #title>
          Poste irreparable
        </template>
        <template #content>
          <div class="mt-4">
            <div class="flex flex-wrap">
              <div class="px-3 pb-8 w-full lg:w-1/2">
                <label class="form-label">Motif:</label>
                <multiselect v-model="form.irreparable.reason" deselect-label="supprimer" placeholder="Select one" :searchable="true" :clear-on-select="false"
                             :options="rejectReasons" open-direction="bottom">
                </multiselect>
                <div v-if="errors.reason" class="form-error">{{ errors.reason }}</div>
              </div>
              <file-input v-model="form.irreparable.attachment" :error="errors.attachment" class="px-3 pb-8 w-full lg:w-1/2" type="file" accept="image/*" label="Photo" />
              <div class="px-3 pb-8 w-full lg:w-full">
                <textarea-input v-model="form.irreparable.comment" :error="errors.comment" label="Commentaire Technique" :optional="true"/>
              </div>
            </div>
          </div>
        </template>
        <template #footer>
          <jet-secondary-button @click.native="irreparableForm = false">
            Annuler
          </jet-secondary-button>
          <jet-button class="bg-green-600 hover:bg-green-500 focus:border-green-700 focus:shadow-outline-green"
                      :class="{ 'opacity-25': form.processing }" :disabled="form.processing"
                      @click.native="sendToTest('irreparable')">
            Envoyer
          </jet-button>
        </template>
      </jet-dialog-modal>

      <!-- comment Modal -->
      <jet-dialog-modal :show="commentForm" :closeable="false" @close="commentForm = false">
        <template #title>
          Ajouter un commentaire
        </template>
        <template #content>
          <div class="mt-4">
            <div class="flex flex-wrap">

              <div class="px-3 pb-8 w-full lg:w-full">
                <textarea-input v-model="form.comment.comment" :error="errors.comment" label="Commentaire Technique" :optional="true"/>
              </div>
            </div>
          </div>
        </template>
        <template #footer>
          <jet-secondary-button @click.native="commentForm = false">
            Annuler
          </jet-secondary-button>
          <jet-button class="bg-green-600 hover:bg-green-500 focus:border-green-700 focus:shadow-outline-green"
                      :class="{ 'opacity-25': form.processing }" :disabled="form.processing"
                      @click.native="sendToTest">
            Envoyer
          </jet-button>
        </template>
      </jet-dialog-modal>

    </div>
    <pagination :links="repairs.links"/>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Layouts/AppLayout'
import mapValues from 'lodash/mapValues'
import pickBy from 'lodash/pickBy'
import SearchFilter from '@/Shared/SearchFilter'
import throttle from 'lodash/throttle'
import Pagination from '@/Shared/Pagination'
import LoadingButton from '@/Shared/LoadingButton'
import TextInput from "@/Shared/TextInput"
import SelectInput from '@/Shared/SelectInput'
import JetDialogModal from '@/Jetstream/DialogModal'
import JetInputError from '@/Jetstream/InputError'
import JetButton from '@/Jetstream/Button'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import JetDangerButton from '@/Jetstream/DangerButton'
import TextareaInput from "@/Shared/TextareaInput"
import FileInput from '@/Shared/FileInput'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'


export default {
  metaInfo: {title: 'Liste Postes'},
  layout: Layout,
  components: {
    TextInput,
    Icon,
    SearchFilter,
    Pagination,
    LoadingButton,
    SelectInput,
    JetDialogModal,
    JetInputError,
    JetButton,
    JetSecondaryButton,
    TextareaInput,
    JetDangerButton,
    Multiselect,
    FileInput
  },
  props: {
    errors: Object,
    repairs: Object,
    models: Array,
    categories: Array,
    malfunctions: Array,
    repairsType: Array,
    repairsPrice: Array,
    filters: Object,
  },
  data() {
    return {
      selectedItems: [],
      parts: [],
      rejectReasons: [ "Oxydé", "Bricolé", "Oxydé et bricolé", "Cassé", "Déformé", "Brulé", "Garantie dépassée", "Produit étranger", "IMEI illisible", "Manque IMEI", "Produit non recouvert par garantie SAV"],
      selectAll: false,
      sending: false,
      repairForm: false,
      sendToTestForm: false,
      sendToDevisForm: false,
      orderPartsForm: false,
      irreparableForm: false,
      commentForm: false,
      sForm: {
        search: this.filters.search,
      },
      form: {
        processing: false,
        test: {
          repairId: null,
          repairsDone: null,
          comment: null,
          commentClient: null,
          imei: null,
          swap_imei: null,
          hasSwap: false,
        },
        quote: {
          repairId: null,
          reparationType: null,
          parts: null,
          comment: null,
          clientComment: null,
          totalPrice: null,
        },
        irreparable: {
          repairId: null,
          comment: null,
          reason: null,
          attachment: null
        },
        comment: {
          comment: null
        },
        parts: {
          repairId: null,
          test: false,
          parts: null,
          comment: null,
          processing: false,
        },
        repair: {
          repairId: null,
          imei: null,
          model: null,
          malfunction: null,
          with_parts: 0,
          warranty: 0,
          partsWarranty: [],
          with_quote: 0,
          parts: [],
          partsCategory: null,
          reparationType: null,
          reparations: null,
          reparationTypePrice: null,
          percentMargins: null,
          amountMargins: null,
          amount: null,
          percent: null,
          calculatedPrice: null,
          processing: false,
        }
      },
    }
  },
  computed: {
    showMargin() {
      return this.form.repair.with_quote == 1 && this.form.repair.with_parts == 1
    },
    showPredefinedPrices() {
      return this.form.repair.with_quote == 1 && this.form.repair.with_parts == 0 && this.form.repair.reparationType != null
    },
  },
  watch: {
    'repairForm':function () {
      this.calculMargin()
    },
    'form.repair.model': function () {
      this.form.repair.parts = null
    },
    'form.repair.with_parts': function (newVal) {
      if (newVal == 0) {
        this.calcul(this.form.repair.reparationTypePrice)
      }

      this.calculMargin()
    },
    'form.repair.with_quote': function (newVal) {
      if (newVal == 1) {
        this.calcul(this.form.repair.reparationTypePrice)
        this.calculMargin()
      }
    },
    'form.repair.parts': function (newVal, oldVal) {
      if (newVal !== undefined && newVal !== null && oldVal !== undefined && oldVal !== null) {
        if (newVal.length < oldVal.length) {
          this.form.repair.partsWarranty = this.form.repair.partsWarranty.filter(function (pw) {
            let found = false
            newVal.forEach(function (part) {
              if (pw.id == part.id) {
                found = true
                return true
              }
            })

            return found;
          });
        }else {
          let obj = {};
          obj.target = {}
          obj.target.value = 0
          this.partsWarrantyHandler(obj, newVal[newVal.length - 1].id)
        }
      }
      this.calculMargin()
    },
    'form.repair.amount': function () {
      this.calculMargin()
    },
    'form.repair.percent': function () {
      this.calculMargin()
    },
    sForm: {
      handler: throttle(function () {
        let query = pickBy(this.sForm)
        this.$inertia.replace(this.route('tech.list', Object.keys(query).length ? query : {remember: 'forget'}), {
          preserveScroll: true,
          preserveState: true,
        })
      }, 150),
      deep: true,
    },
  },
  methods: {
    reset() {
      this.sForm = mapValues(this.sForm, () => null)
    },
    select() {
      this.selectedItems = [];
      if (this.selectAll) {
        for (let i in this.repairs.data) {
          if (this.repairs.data.hasOwnProperty(i)) {
            this.selectedItems.push(this.repairs.data[i].id);
          }
        }
      }
    },
    showRepairForm(repair) {
      this.repairForm = true
      this.form.repair = mapValues(this.form.repair, () => null)
      this.form.repair.repairId = repair.id
      this.form.repair.imei = repair.imei
      this.form.repair.model = repair.modelObj
      this.form.repair.malfunction = repair.malfunctionObj
      this.form.repair.warranty = repair.under_warranty
      this.form.repair.with_parts = repair.with_parts
      this.form.repair.with_quote = repair.with_quote
      this.form.repair.percentMargins = repair.percentMargins
      this.form.repair.amountMargins = repair.amountMargins
      this.form.repair.partsWarranty = repair.partsWarranty
      this.findParts(this.form.repair)
      this.$nextTick(() => {
        if (repair.quote != null) {
          this.form.repair.calculatedPrice = repair.quote.price
          if (repair.quote.percent != null) this.form.repair.percent = {value: repair.quote.percent.toString()}
          if (repair.quote.amount != null) this.form.repair.amount = {value: repair.quote.amount.toString()}
        }
        if (repair.parts != null) {
          this.form.repair.parts = repair.parts
          this.form.repair.reparations = repair.reparations
        }
        if (repair.repair_type != null) this.form.repair.reparationType = repair.repair_type
        if (repair.repair_type != null && repair.with_quote == 1 && repair.with_parts == 0) this.form.repair.reparationTypePrice = parseFloat(this.form.repair.calculatedPrice)
        this.calculMargin()
      })
      if (repair.repair_type != null && repair.with_quote == 1 && repair.with_parts == 0) this.form.repair.reparationTypePrice = parseFloat(this.form.repair.calculatedPrice)
      if (!repair.canUpdate) this.form.repair.processing = true
    },
    testFormDisabled(repair) {
      return (repair.with_parts == null && repair.with_quote == null) ||
        (repair.with_parts == 1 && (repair.order == null || (repair.order != null && repair.order.confirmed_by == null))) ||
        (repair.with_quote == 1 && (repair.quote == null || (repair.quote != null && repair.quote.accepted == null)))
    },
    showTestForm(repair) {
      if (this.testFormDisabled(repair)) return
      this.sendToTestForm = true
      this.form.test = mapValues(this.form.test, () => null)
      if (repair.hasSwap) this.form.test.hasSwap = true
      this.form.test.repairId = repair.id
      this.form.test.imei = repair.imei
    },
    showDevisForm(repair) {
      if (repair.with_quote != 1) {
        return
      }
      this.sendToDevisForm = true
      this.form.quote = mapValues(this.form.quote, () => null)
      this.form.quote.repairId = repair.id
      this.form.quote.totalPrice = repair.quote.price
      if (repair.parts != null) this.form.quote.parts = repair.parts
      if (repair.repair_type != null) this.form.quote.reparationType = repair.repair_type
    },
    orderPartsFormDisabled(repair) {
      return (repair.with_parts != 1 || (repair.quote != null && repair.quote.accepted != 1) || (repair.order != null && repair.order.confirmed_by != null))
    },
    showOrderPartsForm(repair) {
      if (this.orderPartsFormDisabled(repair)) return
      this.orderPartsForm = true
      this.form.parts = mapValues(this.form.parts, () => null) // reset the form
      this.form.parts.repairId = repair.id
      if (repair.parts != null) this.form.parts.parts = repair.parts
      if (repair.order != null) this.form.parts.processing = true
    },
    showIrreparableForm(repair) {
      if (repair.order != null) return
      this.irreparableForm = true
      this.form.irreparable = mapValues(this.form.irreparable, () => null)
      this.form.irreparable.reason = null
      this.form.irreparable.repairId = repair.id
    },
    showCommentForm(repair) {
      this.commentForm = true
    },
    sendToTest(formName) {
      const data = new FormData()
      if (formName === "test") {
        data.append('test', JSON.stringify(this.form.test) || '')
      } else if (formName === "irreparable") {
        data.append('irreparable', JSON.stringify(this.form.irreparable) || '')
        data.append('attachment', this.form.irreparable.attachment || '')
      }

      this.$inertia.post(this.route('tech.sendToTest'), data, {
        preserveScroll: true,
        onStart: () => this.sending = true,
        onFinish: () => this.sending = false,
        onSuccess: () => {
          if (Object.keys(this.$page.props.errors).length === 0) {
            if (formName === "test")  this.sendToTestForm = false
            if (formName === "irreparable") this.irreparableForm = false
          }
        },
        onError: (errors) => {
          alert(errors)
        },
      })
    },
    sendToDevis() {
      const data = new FormData()
      data.append('quote', JSON.stringify(this.form.quote) || '')
      data.append('_method', 'put')
      this.$inertia.post(this.route('tech.sendToDevis',this.form.quote.repairId), data, {
        preserveScroll: true,
        onStart: () => this.sending = true,
        onFinish: () => this.sending = false,
        onSuccess: () => {
          if (Object.keys(this.$page.props.errors).length === 0) {
            this.sendToDevisForm = false
          }
        },
        onError: (errors) => {
          alert(errors)
        },
      })
    },
    sendPartsOrder() {
      const data = new FormData()
      data.append('parts', JSON.stringify(this.form.parts) || '')
      this.$inertia.post(this.route('tech.orderParts', this.form.parts.repairId), data, {
        preserveScroll: true,
        onStart: () => this.sending = true,
        onFinish: () => this.sending = false,
        onSuccess: () => {
          if (Object.keys(this.$page.props.errors).length === 0) {
            this.orderPartsForm = false
          }
        },
        onError: (errors) => {
          alert(errors)
        },
      })
    },
    cancelPartsOrder() {

      const data = new FormData()
      data.append('comment', this.form.parts.comment || '')
      this.$inertia.post(this.route('tech.cancelOrderParts', this.form.parts.repairId), data, {
        preserveScroll: true,
        onStart: () => this.sending = true,
        onFinish: () => this.sending = false,
        onSuccess: () => {
          if (Object.keys(this.$page.props.errors).length === 0) {
            this.orderPartsForm = false
          }
        },
        onError: (errors) => {
          alert(errors)
        },
      })
    },
    findParts(form) {
      if (form.model == null) return
      return axios.get(this.route('tech.searchParts'), {
        params: {
          shop_id: this.$page.props.user.shop.id,
          model_id: form.model.id,
          brand_id: form.model.brand_id,
        }})
        .then(response => {
          this.parts = response.data
        }).catch(error => {
          alert(error)
        })
    },
    async filterParts() {
      if (this.form.repair.partsCategory == null) return
      await this.findParts(this.form.repair)
      //await new Promise(r => setTimeout(r, 2000));
      const ps = this.parts.filter(part => part.category == this.form.repair.partsCategory.id)

      this.parts = ps
    },
    saveRepairParams() {
      if (this.form.repair.processing) {
        alert("action non autorisée")
        return
      }
/*      if (this.form.repair.with_parts == 1 && this.form.repair.with_quote == 1){
        var conf = confirm("prix des pieces confirmer avec le stock manager ?")
        if (!conf) return;
      }*/
      const data = new FormData()
      data.append('repair', JSON.stringify(this.form.repair) || '')

      this.$inertia.post(this.route('tech.saveRepairParams'), data, {
        preserveScroll: true,
        onStart: () => {
          this.form.processing = true
          this.form.repair.processing = true
        },
        onFinish: () => {
          this.form.processing = false
          this.form.repair.processing = false
        },
        onSuccess: () => {
          if (Object.keys(this.$page.props.errors).length === 0) {
            this.repairForm = false
          }
        },
        onError: (errors) => {
        },
      })
    },
    partsWarrantyHandler(event, id) {
      let optionValue = event.target.value;
      let found = false;
      this.form.repair.partsWarranty.forEach(function (partWarranty) {
        if (partWarranty.id == id) {
          partWarranty.isUnderWarranty = optionValue == 1
          this.calculMargin()
          found = true
        }
      }.bind(this))
      if (!found) {
        let partWarranty = {}
        let obj = {};
        obj.id = id
        obj.isUnderWarranty = optionValue == 1
        partWarranty = obj
        this.form.repair.partsWarranty.push(partWarranty)
        this.calculMargin()
      }
    },
    partIsChecked(id) {
      let checked = false
      this.form.repair.partsWarranty.forEach(function (part) {
          if (part.id == id) {
            checked = part.isUnderWarranty
          }
      })
      return checked
    },
    // predefined repairs fixed price
    calcul(price) {
      if (price == null) {
        this.form.repair.calculatedPrice = null
        return
      }
      this.form.repair.calculatedPrice = price
    },
    calculMargin() {
      if (this.form.repair.with_parts == 0 || this.form.repair.with_quote == 0) {
        return;
      }
      this.form.repair.calculatedPrice = null
      if (this.form.repair.parts != null && this.form.repair.parts.length > 0) {
        let total = 0
        this.form.repair.parts.forEach(function (item, index) {
          if (this.form.repair.partsWarranty != null && this.form.repair.partsWarranty.length > 0) {
            this.form.repair.partsWarranty.forEach(function (part, index) {
              if (part.id !== undefined && part.id == item.id && part.isUnderWarranty == 0) {
                total = total + Number(item.cost)
              }
            })
          }
        }.bind(this));
        this.form.repair.calculatedPrice = total.toString()
      }

      if (this.form.repair.calculatedPrice == 0 || this.form.repair.calculatedPrice == null) {
        return
      }

      if (this.form.repair.percent != null && this.form.repair.percent.value != 0) {
        let margin = (this.form.repair.percent.value * this.form.repair.calculatedPrice) / 100
        let amount = Number(this.form.repair.calculatedPrice) + margin
        this.form.repair.calculatedPrice = amount.toString()
      }

      if (this.form.repair.amount != null && this.form.repair.amount.value != 0) {
        let amount = Number(this.form.repair.calculatedPrice) + Number(this.form.repair.amount.value)
        this.form.repair.calculatedPrice = amount.toString()
      }
    },
  },
}
</script>
